import { styled } from "@mui/system";
import { Table, TableCell, TableContainer, TableHead } from "@mui/material";


export const StyledTableContainer = styled(TableContainer)(() => ({}));

export const StyledTable = styled(Table)(({ theme }) => {
  return {
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: theme.palette.background.inactive
  }
})

export const StyledTableHead = styled(TableHead)(({theme}) => {
  return {
     backgroundColor: theme.palette.background.accent,

     "& .MuiTableCell-root.MuiTableCell-head.MuiTableCell-sizeMedium": {
       fontSize: 14,
       fontWeight: 500,
       padding: theme.spacing(0.5, 1.5)
     }
  }
})

export const StyledTableCell = styled(TableCell)(({theme}) => {
  return {
    fontSize: 14,
    padding: theme.spacing(1.5)
  }
})
